import React, { useState, useEffect } from "react";
import {
  Card,
  CardBody,
  CardTitle,
  Container,
  Row,
  Col,
  Progress,
  CardImg,
  Button,
  UncontrolledTooltip,
} from "reactstrap";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import CircleChart4 from "dashboard/store-management/variables/CircleChart4";
import Cookies from "js-cookie";

import { api } from "../../../api";
import CircleChartVendor from "../variables/CircleChatVendor";

const goodMessageStyle = `
.good-message {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #E08681;
  color: #222;
  font-weight: bold;
  font-size: 1.2rem;
  border-radius: 10px;
  padding: 0.5em 1.5em;
  margin: 0 auto;
  white-space: nowrap;
  max-width: 100vw;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}
`;

const Dashboard4 = () => {
  const [timeOfDay, setTimeOfDay] = useState("");

  const getTimeOfDay = (date) => {
    const hour = date.getHours();
    if (hour >= 0 && hour < 12) {
      return "Morning🌞";
    } else if (hour >= 12 && hour < 18) {
      return "Afternoon⛅";
    } else {
      return "Night🌙";
    }
  };

  useEffect(() => {
    setTimeOfDay(getTimeOfDay(new Date()));
  }, []);

  const [upCards, setUpCards] = useState([]);
  const handleEquipmentCards = async () => {
    try {
      const company_id = Cookies.get('company_id');
      const response = await api.get(`countdashboardSTM.php?company_id=${company_id}`);
      if (response.data.status === "success") {
        setUpCards(response.data.data);
      } else {
        console.error("API Error:", response.data.message);
      }
    } catch (error) {
      console.error("Error Fetching Data", error);
    }
  };

  useEffect(() => {
    handleEquipmentCards();
  }, []);

  console.log("Dashboardcards", upCards);

  return (
    <>
      <div className="header bg-gradient-info py-7 py-lg-8">
        <Container fluid>
          <Row className="d-flex justify-content-center align-items-center">
            {/* Total Items Card */}
            <Col lg="6" xl="3" className="mb-3">
              <Card
                className="card-stats mb-4 mb-xl-0"
                style={{
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                  backgroundColor: "#fff",
                  borderRadius: "15px",
                }}
              >
                <CardBody className="p-3">
                  <div className="d-flex justify-content-between align-items-center">
                    <CardTitle
                      className="mb-0"
                      style={{ fontSize: "16px", fontWeight: "600" }}
                    >
                      Total In-House Stock
                    </CardTitle>
                    <span className="h3 font-weight-bold m-0">
                      {upCards[0]?.total_items || "N/A"}
                    </span>
                  </div>
                </CardBody>
              </Card>
            </Col>

            {/* Required Items Card */}
            <Col lg="6" xl="3" className="mb-3">
              <Card
                className="card-stats mb-4 mb-xl-0"
                style={{
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                  backgroundColor: "#fff",
                  borderRadius: "15px",
                }}
              >
                <CardBody className="p-3">
                  <div className="d-flex justify-content-between align-items-center">
                    <CardTitle
                      className="mb-0"
                      style={{ fontSize: "16px", fontWeight: "600" }}
                    >
                      Requested Items
                    </CardTitle>
                    <span className="h3 font-weight-bold m-0">
                      {upCards[1]?.requested_items || "N/A"}
                    </span>
                  </div>
                </CardBody>
              </Card>
            </Col>

            {/* Today's Request Card */}
            <Col lg="6" xl="3" className="mb-3">
              <Card
                className="card-stats mb-4 mb-xl-0"
                style={{
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                  backgroundColor: "#fff",
                  borderRadius: "15px",
                }}
              >
                <CardBody className="p-3">
                  <div className="d-flex justify-content-between align-items-center">
                    <CardTitle
                      className="mb-0"
                      style={{ fontSize: "16px", fontWeight: "600" }}
                    >
                      Today's Request
                    </CardTitle>
                    <span className="h3 font-weight-bold m-0">
                      {upCards[2]?.todays_requests || "N/A"}
                    </span>
                  </div>
                </CardBody>
              </Card>
            </Col>

            {/* Emergency Requirement Card */}
            <Col lg="6" xl="3" className="mb-3">
              <Card
                className="card-stats mb-4 mb-xl-0"
                style={{
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                  backgroundColor: "#fff",
                  borderRadius: "15px",
                }}
              >
                <CardBody className="p-3">
                  <div className="d-flex justify-content-between align-items-center">
                    <CardTitle
                      className="mb-0"
                      style={{ fontSize: "16px", fontWeight: "600" }}
                    >
                      Total Vendor Stock{" "}
                    </CardTitle>
                    <span className="h3 font-weight-bold m-0">
                      {upCards[3]?.total_vendor_product_stock || "N/A"}
                    </span>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row className="mt-5 d-flex flex-column align-items-center">
            <Col xs="12" className="mb-4 pl-0 pr-0">
              <Card
                className="card-stats -sm p-2"
                style={{
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                  backgroundColor: "#fff",
                  borderRadius: "15px",
                }}
              >
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h2 className="font-weight-bold mb-0">
                    In-House Available Stocks
                  </h2>
                  <div
                    className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center"
                    style={{ width: "40px", height: "40px" }}
                  >
                    <i
                      className="fa-solid fa-chart-pie"
                      style={{ fontSize: "1.5rem" }}
                    ></i>
                  </div>
                </div>
                <Col>
                  <CircleChart4 />
                </Col>
              </Card>
            </Col>
            <Col xs="12" className="mb-4 pl-0 pr-0">
              <Card
                className="card-stats -sm p-2"
                style={{
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                  backgroundColor: "#fff",
                  borderRadius: "15px",
                }}
              >
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h2 className="font-weight-bold mb-0">
                    Vendor Available Stocks
                  </h2>
                  <div
                    className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center"
                    style={{ width: "40px", height: "40px" }}
                  >
                    <i
                      className="fa-solid fa-chart-pie"
                      style={{ fontSize: "1.5rem" }}
                    ></i>
                  </div>
                </div>
                <Col>
                  <CircleChartVendor />
                </Col>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default Dashboard4;
